import { useCallback } from 'react'

import { Banner } from '@loadsmart/miranda-react'

import { useAnalytics } from 'core/analytics/useAnalytics'

import { useTrackingOnboardingContext } from './TrackingOnboardingContext'

export default function UserOnboardedBanner() {
  const { track } = useAnalytics()

  const { showUserOnboardedBanner, openTrackingConnectionDrawer } = useTrackingOnboardingContext()

  const handleSetupItNow = useCallback(() => {
    openTrackingConnectionDrawer()
    track('Open setup: Confirm preferred method banner')
  }, [openTrackingConnectionDrawer, track])

  return showUserOnboardedBanner ? (
    <Banner variant="warning">
      <Banner.Title>Confirmation of your preferred tracking method is pending</Banner.Title>
      <Banner.Description>
        To improve your experience and streamline your load management, please choose your preferred
        tracking method. This will help us tailor the page layout to suit your needs perfectly!
      </Banner.Description>
      <Banner.Actions>
        <Banner.ActionPrimary onClick={handleSetupItNow}>Setup it now</Banner.ActionPrimary>
      </Banner.Actions>
    </Banner>
  ) : null
}
